import { render, staticRenderFns } from "./TableResponsiblesActions.vue?vue&type=template&id=5311c58a&scoped=true&"
import script from "./TableResponsiblesActions.vue?vue&type=script&lang=js&"
export * from "./TableResponsiblesActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5311c58a",
  null
  
)

export default component.exports